import React from 'react'
import { data } from '../Constant/data'
import Button from '../Common/Button/Button';
import { NavLink } from 'react-router-dom';

const HeroSection = () => {
    let bannerData = data.heroSection;
    return (
        <>
            <section className="banner" id='home'>
                <figure className='bg_img cover'>
                    <img src={bannerData?.decor?.url} alt={bannerData?.decor?.alt} />
                </figure>
                <div className="container">
                    <div className="left">
                        <div className="title_wrapper mb">
                            <h1 className='text_xxxl '>{bannerData.title}</h1>
                            <span className='text_xl fw_500'>{bannerData?.subTitle?.content}<span className="text_red">{bannerData?.subTitle?.highlight}</span></span>
                        </div>
                        <p className='text_lg2'>{bannerData?.description}</p>
                        <NavLink
                            label={bannerData?.button?.title}
                            className="btn mt primary"
                            to={bannerData?.button?.href}
                        >{bannerData?.button?.title}</NavLink>
                        {/* <Button
                            label={bannerData?.button?.title}
                            className="btn mt"
                            type="primary"
                            href={bannerData?.button?.href}
                        /> */}
                    </div>
                    <figure className="right bg_img">
                        <img src={bannerData?.image?.url} alt={bannerData?.image?.alt} className='icon' />
                    </figure>
                    <figure className="bottom bg_img">
                        <img src={bannerData?.bottom_decor_image?.url} alt={bannerData?.bottom_decor_image?.alt} className='icon' />
                    </figure>
                </div>
            </section>
        </>
    )
}

export default HeroSection
